import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterDateValue,
  UniversalFilterDateModes,
  UniversalFilterDateOnChange
} from './UniversalFilterDate.types';

import { useUniversalFilterDate } from './hooks/useUniversalFilterDate';

import { UniversalFilterDateIsAfterMode } from './components/UniversalFilterDateIsAfterMode';
import { UniversalFilterDateIsBeforeMode } from './components/UniversalFilterDateIsBeforeMode';
import { UniversalFilterDateIsMode } from './components/UniversalFilterDateIsMode';
import { UniversalFilterDateIsOnOrAfterMode } from './components/UniversalFilterDateIsOnOrAfterMode';
import { UniversalFilterDateIsOnOrBeforeMode } from './components/UniversalFilterDateIsOnOrBeforeMode';
import { UniversalFilterDateIsWithinMode } from './components/UniversalFilterDateIsWithinMode';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterDateProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterDateValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterDateOnChange;
}

function UniversalFilterDate({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterDateProps) {
  const {
    modeOptions,
    filterState,
    handleModeChange,
    handleFilterStateChange
  } = useUniversalFilterDate({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterDateModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {filterState.mode === UniversalFilterDateModes.IS ? (
        <UniversalFilterDateIsMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
      {filterState.mode === UniversalFilterDateModes.IS_WITHIN ? (
        <UniversalFilterDateIsWithinMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
      {filterState.mode === UniversalFilterDateModes.IS_BEFORE ? (
        <UniversalFilterDateIsBeforeMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
      {filterState.mode === UniversalFilterDateModes.IS_AFTER ? (
        <UniversalFilterDateIsAfterMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
      {filterState.mode === UniversalFilterDateModes.IS_ON_OR_BEFORE ? (
        <UniversalFilterDateIsOnOrBeforeMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
      {filterState.mode === UniversalFilterDateModes.IS_ON_OR_AFTER ? (
        <UniversalFilterDateIsOnOrAfterMode
          filterState={filterState}
          autoFocus={autoFocus}
          onFilterStateChange={handleFilterStateChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterDate;
